import "./App.css";
import React, { useEffect } from "react";
import { AegisClient, useAuth } from "@nike/aegis-auth-react";
import config from "../config/config.js";
import { setGlobalHeader } from "../utilities/http";
import { Button, PageSpinner } from "@nike/epic-react-ui";
import Footer from "../components/Footer";
import { Navigate, Route, Routes } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import RoutingPanel from "../components/RoutingPanel";
import HomePage from "../components/HomePage";
import {
  ROUTE_HOME,
  ROUTE_PALLET_GROUP_ASSIGNMENT,
} from "../constants/routes";

const client = new AegisClient({
  qa: !config.isProd,
  ...config.oAuth,
});

function App() {
  const navigate = useNavigate();

  const {
    loginComplete,
    isLoggedIn,
    clearLogin,
    accessToken,
    tokenClaims,
    loginError,
  } = useAuth(client);

  const loggedIn = typeof isLoggedIn === "function" ? isLoggedIn() : isLoggedIn;

  useEffect(() => {
    if (accessToken) {
      setGlobalHeader("Authorization", `Bearer ${accessToken}`);
    }
  }, [accessToken]);

  if (!loginComplete) {
    return <PageSpinner show={true} />;
  }

  if (loginError && !accessToken) {
    const errorDetail =
      loginError?.errorSummary ||
      loginError?.message ||
      loginError?.error ||
      (typeof loginError === "string" ? loginError : null);

    return (
      <div style={{ margin: "50px" }}>
        <span className="epic-body-text-1 table-label">
          Sign-in failed. Close this tab and try again, or check the browser
          console for Okta errors.
        </span>
        {errorDetail && (
          <p className="epic-body-text-2 table-label" style={{ marginTop: "12px" }}>
            {errorDetail}
          </p>
        )}
        <p>
          <Button onClick={() => client.login()}>Retry login</Button>
        </p>
      </div>
    );
  }

  if (!loggedIn || !accessToken) {
    return <LoggedOut onLogin={() => client.login()} />;
  }

  const adGroup = tokenClaims?.groups;

  function handleLogout() {
    setGlobalHeader("Authorization", null);
    clearLogin();
    client.logout();
    navigate("/logout");
  }

  return (
    <div>
      <Routes>
        <Route path="/" element={<Navigate to={ROUTE_HOME} replace />} />
        <Route
          path={ROUTE_HOME}
          element={
            <HomePage handleLogout={handleLogout} displayLogout={true} />
          }
        />
        <Route
          path={ROUTE_PALLET_GROUP_ASSIGNMENT}
          element={
            <RoutingPanel
              adGroup={adGroup}
              handleLogout={handleLogout}
              displayLogout={true}
            />
          }
        />
        <Route
          path="/logout"
          element={<LoggedOut onLogin={() => (window.location.href = "/")} />}
        />
      </Routes>

      <Footer />
    </div>
  );
}

function LoggedOut({ onLogin }) {
  return (
    <div style={{ margin: "50px" }}>
      <div style={{ marginBottom: "20px" }}>
        <span className="epic-body-text-1 table-label">
          You have been logged out from application.
        </span>
        <p>
          <span className="epic-body-text-1 table-label">
            Close the browser to log out from Okta session.
          </span>
        </p>
      </div>
      <Button onClick={onLogin}>Login</Button>
    </div>
  );
}

export default App;
